import { Typography } from 'antd'
import { format } from 'date-fns-tz'

import { RefundTableCell } from '../table.common'

const { Text } = Typography

export const CellRefundDate: RefundTableCell<Date> = (value) => (
	<Text>{value ? format(value, 'yyyy-MM-dd', { timeZone: 'Asia/Seoul' }) : ''}</Text>
)
